import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import DescriptionProduct from 'components/Shared/DescriptionProduct';
import ExpandMoreIcon from 'mdi-react/ExpandMoreIcon';
import React, { useEffect, useState } from 'react';
import { useStyles } from './styles';

import { IListProductProps } from 'interfaces/listProduct';
import { ListProduct } from '../ListProduct';

interface IProps extends IListProductProps {
  expanded: boolean;
}

export function ListProductWithChildren({ product, onSelected, expanded }: IProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  const classes = useStyles();
  return (
    <ExpansionPanel
      className={classes.expandablePanel}
      expanded={isExpanded}
      onChange={(_, open) => setIsExpanded(open)}
    >
      <ExpansionPanelSummary
        className={classes.expandableTitle}
        expandIcon={<ExpandMoreIcon className={classes.icon} />}
      >
        <DescriptionProduct image={product?.image} productId={product?.id} title={product?.name} />
      </ExpansionPanelSummary>

      <ExpansionPanelDetails className={classes.expandableDetails}>
        {product?.children?.map(child => (
          <ListProduct product={child} onSelected={onSelected} key={child?.id} />
        ))}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}
